import { all, put, takeLatest } from 'redux-saga/effects';
import { Action } from 'typescript-fsa';
import { SqlStatistics } from '../../../services/betting';
import { fetchWrapperFunc } from '../../../utils';
import { getSqlStatisticsApi, ServerType } from '../../System/systemConfig';
import {
    loadSqlStatisticsAction,
    setSqlStatisticsAction,
    setSqlStatisticsServerAvailable,
    SQL_STATS_CLEAR,
    SQL_STATS_LOAD
} from './actions';

function* loadSqlStatisticsGenerator(action: Action<ServerType>) {
    const server = action.payload;

    if (!server) {
        console.info('no server url found for job server ' + server);
    } else {
        const sqlApi = getSqlStatisticsApi(server);
        yield* fetchWrapperFunc(
            () => sqlApi.getSqlStatistics(),
            [
                (r: SqlStatistics[]) => setSqlStatisticsAction({ serverName: server, stats: r }),
                (r: SqlStatistics[]) => setSqlStatisticsServerAvailable({ serverName: server, available: true })
            ],
            () => setSqlStatisticsServerAvailable({ serverName: server, available: false })
        );
    }
}

function* clearSqlStatisticsGenerator(action: Action<ServerType>) {
    const server = action.payload;

    if (!server) {
        console.info('no server url found for job server ' + server);
    } else {
        const sqlApi = getSqlStatisticsApi(server);
        yield* fetchWrapperFunc(() => sqlApi.clearSqlStatistics());
        yield put(loadSqlStatisticsAction(server));
    }
}

function* watchForSqlStatistics() {
    yield takeLatest(SQL_STATS_LOAD, loadSqlStatisticsGenerator);
    yield takeLatest(SQL_STATS_CLEAR, clearSqlStatisticsGenerator);
}

export function* sqlStatisticSagas() {
    yield all([watchForSqlStatistics()]);
}
